module.exports = __webpack_public_path__ + "img/polydium.21582fc6.jpg";